import { makeStyles, CircularProgress } from '@material-ui/core';
import CheckIcon from '@material-ui/icons/Check';
import { Form, Field } from 'react-final-form';
import * as yup from 'yup';
import {
  Button,
  FormButtons
} from '../../components/common';
import AttachmentCard, {
  Attachment
} from '../../components/common/attachment-card';
import { lengthField } from '../../utils/form';
import { length } from '../../utils/wysiwyg';
import { TextFieldWysiwyg } from './wrappers';
import { yupValidate } from '../../utils/yup';

interface PropsEditInput {
  materials?: string;
  handleSelectFile: (
    e: React.ChangeEvent<HTMLInputElement>,
    file: File
  ) => void;
  handleSave: (materials: string) => void;
  loading: boolean;
  attachments: Attachment[];
  handleFileRemove: (index: number) => void;
  handleCancel: () => void;
}

const useStyles = makeStyles({
  attachBtn: {
    marginTop: 24
  },
  attachmentsList: {
    display: 'flex',
    flexWrap: 'wrap',
    margin: '20px 0 -16px -16px'
  },
  attachment: {
    width: '50%',
    boxSizing: 'border-box',
    padding: '0 0 16px 16px'
  },
  formButtons: {
    justifyContent: 'flex-start'
  }
});

const validationSchema = yup.object().shape({
  materials: yup
    .string()
    .test(
      'max-html-length',
      `Materials description HTML is too long. Maximum html size is ${lengthField.wysiwygMaxLength} characters`,
      function (value) {
        if (!value) return true;
        return value.length <= lengthField.wysiwygMaxLength;
      }
    )
    .test(
      'max-text-length',
      `Materials description is too long. Maximum value size is ${lengthField.wysiwygDisplayLimit} characters`,
      function (value) {
        if (!value) return true;
        return length(value) <= lengthField.wysiwygDisplayLimit;
      }
    )
});

const EducationForm = ({
  materials,
  handleSave,
  handleSelectFile,
  loading,
  attachments,
  handleFileRemove,
  handleCancel
}: PropsEditInput) => {
  const classes = useStyles();

  const onSubmit = (values: { materials: string }) => {
    handleSave(values.materials);
  };

  return (
    <Form
      onSubmit={onSubmit}
      initialValues={{ materials }}
      validate={yupValidate(validationSchema)}
      render={({ handleSubmit }) => (
        <form onSubmit={handleSubmit}>
          <Field
            name='materials'
            component={TextFieldWysiwyg}
            placeholder='Materials'
            testid='education-form-materials-input'
            showCount
            maxLength={lengthField.wysiwygDisplayLimit}
          />
          <div className={classes.attachmentsList}>
            {attachments.map((attachment, attachIndex) => (
              <div key={attachIndex} className={classes.attachment}>
                <AttachmentCard
                  attachment={attachment}
                  loading={!attachment.url}
                  onRemove={() => handleFileRemove(attachIndex)}
                />
              </div>
            ))}
          </div>
          <FormButtons className={classes.formButtons}>
            <Button
              data-testid='button-submit-form'
              type='submit'
              disabled={loading}
              startIcon={<CheckIcon />}>
              {loading ? <CircularProgress size={24} color='inherit' /> : 'Save'}
            </Button>
            <Button
              variant='outlined'
              onClick={handleCancel}
              data-testid='button-cancel-form'>
              Cancel
            </Button>
          </FormButtons>
        </form>
      )}
    />
  );
};

export default EducationForm;
